import { render, staticRenderFns } from "./DivisionTeacher.vue?vue&type=template&id=7a4b249e"
import script from "./DivisionTeacher.vue?vue&type=script&lang=js"
export * from "./DivisionTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a4b249e')) {
      api.createRecord('7a4b249e', component.options)
    } else {
      api.reload('7a4b249e', component.options)
    }
    module.hot.accept("./DivisionTeacher.vue?vue&type=template&id=7a4b249e", function () {
      api.rerender('7a4b249e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/grid/DivisionTeacher.vue"
export default component.exports